import { render, staticRenderFns } from "./RailPicture.vue?vue&type=template&id=523aa3af&scoped=true&"
import script from "./RailPicture.vue?vue&type=script&lang=js&"
export * from "./RailPicture.vue?vue&type=script&lang=js&"
import style0 from "./RailPicture.vue?vue&type=style&index=0&id=523aa3af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523aa3af",
  null
  
)

export default component.exports